module.exports = require("core-js/library/fn/promise");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/promise.js
// module id = 32
// module chunks = 92